import cookieModel from './cookieModel';

const SUPER_ADMIN_USER_TYPE = 0;
const USER_TYPE_COOKIE = 'ticketlab_user_type';
const ORGANISER_USER_ROUTE_ACCESS_ERROR =
  'You do not have permission to view another organiser\'s events.';

const authModel = {
  SUPER_ADMIN_USER_TYPE,
  USER_TYPE_COOKIE,

  getUserType() {
    const value = cookieModel.getCookie(USER_TYPE_COOKIE);
    return value === '' ? null : value;
  },

  setUserType(userType) {
    if (userType == null || userType === '') {
      cookieModel.removeCookie(USER_TYPE_COOKIE);
      return;
    }
    cookieModel.setCookie(USER_TYPE_COOKIE, String(userType));
  },

  clearUserType() {
    cookieModel.removeCookie(USER_TYPE_COOKIE);
  },

  isUserTypeUnknown(userType) {
    return userType == null || userType === '';
  },

  isSuperAdmin(userType) {
    if (authModel.isUserTypeUnknown(userType)) {
      return false;
    }
    return Number(userType) === SUPER_ADMIN_USER_TYPE;
  },

  parseUserTypeFromLoginResponse(response) {
    if (response == null) {
      return null;
    }

    const candidates = [
      response.user_type,
      response.userType,
      response.user?.user_type,
      response.user?.userType,
      response.data?.user_type,
      response.data?.userType,
    ];

    for (let i = 0; i < candidates.length; i++) {
      const value = candidates[i];
      if (value != null && value !== '') {
        return value;
      }
    }

    return null;
  },

  shouldIncludeOrganiserUserId(userType, organiserUserId) {
    if (organiserUserId == null || organiserUserId === '') {
      return false;
    }

    return (
      authModel.isSuperAdmin(userType) || authModel.isUserTypeUnknown(userType)
    );
  },

  getOrganiserUserRouteAccessError(userType, organiserUserId, userRole) {
    if (organiserUserId == null || organiserUserId === '') {
      return null;
    }

    if (userRole === 'staff') {
      return ORGANISER_USER_ROUTE_ACCESS_ERROR;
    }

    if (authModel.isUserTypeUnknown(userType)) {
      return null;
    }

    if (authModel.isSuperAdmin(userType)) {
      return null;
    }

    return ORGANISER_USER_ROUTE_ACCESS_ERROR;
  },
};

export default authModel;
